import CustomTitle from '../CustomElements/CustomTitle';
import CustomContainer from '../CustomElements/CustomContainer';
import ConfirmationPage from '../CustomElements/ConfirmationPage';

function BrigadeTransferFencing({ handlerConfirm, t }) {
  return (
    <CustomContainer>
      <CustomTitle titleText={t?.transferTitle} />
      <ConfirmationPage
        onConfirm={handlerConfirm}
        addNew={t?.closeButtonText}
        confirmText={t?.transferFunctionNotAvailable}
      />
    </CustomContainer>
  );
}
export default BrigadeTransferFencing;
